import React from 'react';
import { ClientPastMonthCloses } from './clientPastMonthCloses';

export function OrgDetails({ clientName }) {
  return (
    <div>
      {/* You can add more org details here as needed */}
      <ClientPastMonthCloses clientName={clientName} />
    </div>
  );
}
